export default __webpack_public_path__ + "static/media/1441.c64e7f85.png";